const app = {
  namespace: 'trycedar',
  url: process.env.NEXT_PUBLIC_APP_PUBLIC_URL!,
  internalUrl: process.env.APP_INTERNAL_URL,
  deployedName: `trycedar-${process.env.NEXT_PUBLIC_APP_ENV}`,
  internalRedirectUrl: '',
};

export default app;
